import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import config from '../config';
import {devOpsUrlFor} from './devOpsUrl';

/**
 * FNP-1636: pipelines, code pipelines, repositories and account groups moved
 * to the DevOps application. A bookmarked Console URL for one of them lands on
 * the same page there instead of the Console's 404 page.
 *
 * `location.replace`, so the dead Console URL does not stay in the history.
 */
export const RedirectToDevOps = ({base = config.platform.devops}: {base?: string}) => {
    const {pathname, search, hash} = useLocation();

    useEffect(() => {
        window.location.replace(devOpsUrlFor(base, pathname, search, hash));
    }, [base, pathname, search, hash]);

    return null;
};
